import React, { useState, useEffect } from "react";

import Divider from "@mui/material/Divider";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useWidth } from "../../config/widthSelector";

import PercentageValue from "./percentageValue";

//Jquery
import apiURL from "../../config/environment";
import $ from "jquery";
import MainValue from "./mainValue";
import {format, startOfYear, startOfYesterday, subDays, subYears} from "date-fns";

export default function KPIValues(props) {
  const {
    showActualNumber,
    tooltipSubTitle,
    showMoreDigits,
    usePercentage,
    defaultValues,
    alterTooltip,
    includeUnits,
    invertArrows,
    invertColors,
    endpoint,
    type,
    scatsData,
  } = props;

  const theme = useTheme();
  const breakpoint = useWidth();
  const isPhone = useMediaQuery(theme.breakpoints.down("sm"));

  const [info, setInfo] = useState(defaultValues);

  const calculatePercentage = (minuend, sustraend, decimals) => {
    const difference = minuend - sustraend;
    if (difference > 100) return 100;
    else return difference.toFixed(decimals);
  };

  /*
  Note: We have 5 different variables, each one of them has 4 different variations:

  periodValue = The main value for the specified period
  periodInterval= The string that specified the starting and ending dates for the specified period
  periodValuePercentage = The percentage variation for the specified period
  periodVariation = The actual variation of the specified period

  The periods are: actual, lastYear, lastMonth, previousMonth and thisMonthLastYear

  */

  useEffect(() => {
    let isSubscribed = true;
    if (scatsData === undefined) {
      const token = JSON.parse(localStorage.getItem("userInfo"))?.token;
      $.ajax({
        method: "GET",
        url: apiURL + endpoint,
        contentType: "application/json",
        headers: {
          Authorization: "Bearer " + token,
        },
      }).done((res) => {
        if (isSubscribed) {
          const decimals = showMoreDigits ? 2 : 0;
          setInfo({
            ...defaultValues,
            ...res,
            previousMonthPeriodPercentage: calculatePercentage(
                res.lastMonthPeriodValuePercentage,
                res.previousMonthPeriodVariation,
                decimals,
            ),
            thisMonthLastYearPeriodPercentage: calculatePercentage(
                res.lastMonthPeriodValuePercentage,
                res.thisMonthLastYearPeriodVariation,
                decimals,
            ),
            lastYearPeriodPercentage: calculatePercentage(
                res.actualPeriodValuePercentage,
                res.lastYearPeriodVariation,
                decimals,
            ),
          });
        }
      });
    } else {


      const actualStart = startOfYear(new Date())
      const actualEnd = startOfYesterday()

      const lastYearStart = subYears(actualStart, 1)
      const lastYearEnd = subYears(actualEnd, 1)

      const last30Start = subDays(actualEnd, 30)
        const last30End = actualEnd

      const prev30Last30Start = subDays(last30Start, 30)
        const prev30Last30End = subDays(last30End, 30)

      const prevYearLast30Start = subYears(last30Start, 1)
        const prevYearLast30End = subYears(last30End, 1)

      const actualPeriodInterval = `${format(actualStart, "MM/dd/yyyy")} - ${format(actualEnd, "MM/dd/yyyy")}`
      const lastYearPeriodInterval = `${format(lastYearStart, "MM/dd/yyyy")} - ${format(lastYearEnd, "MM/dd/yyyy")}`
      const lastMonthPeriodInterval = `${format(last30Start, "MM/dd/yyyy")} - ${format(last30End, "MM/dd/yyyy")}`
      const previousMonthPeriodInterval = `${format(prev30Last30Start, "MM/dd/yyyy")} - ${format(prev30Last30End, "MM/dd/yyyy")}`
      const thisMonthLastYearPeriodInterval = `${format(prevYearLast30Start, "MM/dd/yyyy")} - ${format(prevYearLast30End, "MM/dd/yyyy")}`

      if (type === "min") {
        setInfo({
          ...defaultValues,
          ...scatsData.stats,
          actualPeriodInterval,
          lastYearPeriodInterval,
          lastMonthPeriodInterval,
          previousMonthPeriodInterval,
          thisMonthLastYearPeriodInterval,
          actualPeriodValuePercentage: null,
          actualPeriodValue: scatsData.stats.hoursDown.ytd,
          lastYearPeriodPercentage: (scatsData.stats.hoursDown.ytdm1y - scatsData.stats.hoursDown.ytd) / scatsData.stats.hoursDown.ytd * 100,
          lastYearPeriodValue: scatsData.stats.hoursDown.ytdm1y,
          lastMonthPeriodValuePercentage: null,
          lastMonthPeriodValue: scatsData.stats.hoursDown.l30d,
          previousMonthPeriodPercentage: null,
          previousMonthPeriodValue: scatsData.stats.hoursDown.l30dm30d,
          thisMonthLastYearPeriodPercentage: null,
          thisMonthLastYearPeriodValue: scatsData.stats.hoursDown.l30dm1y,
          previousMonthPeriodVariation: (scatsData.stats.hoursDown.l30d/scatsData.stats.hoursDown.l30dm30d - 1) * 100,
          thisMonthLastYearPeriodVariation: (scatsData.stats.hoursDown.l30d/scatsData.stats.hoursDown.l30dm1y - 1) * 100,
          lastYearPeriodVariation: (scatsData.stats.hoursDown.ytd/scatsData.stats.hoursDown.ytdm1y - 1) * 100,

        })
      } else {
        setInfo({
          ...defaultValues,
          ...scatsData.stats,
          actualPeriodInterval,
          lastYearPeriodInterval,
          lastMonthPeriodInterval,
          previousMonthPeriodInterval,
          thisMonthLastYearPeriodInterval,
          actualPeriodValuePercentage: Math.round(scatsData.stats.uptime.ytd * 100) / 100,
          actualPeriodValue: scatsData.stats.hoursDown.ytd,
          lastYearPeriodPercentage: Math.round(scatsData.stats.uptime.ytdm1y * 100) /100,
          lastYearPeriodValue: scatsData.stats.hoursDown.ytdm1y,
          lastMonthPeriodValuePercentage: Math.round(scatsData.stats.uptime.l30d * 100) / 100,
          lastMonthPeriodValue: scatsData.stats.hoursDown.l30d,
          previousMonthPeriodPercentage: Math.round(scatsData.stats.uptime.l30dm30d * 100) /100,
          previousMonthPeriodValue: scatsData.stats.hoursDown.l30dm30d,
          thisMonthLastYearPeriodPercentage: Math.round(scatsData.stats.uptime.l30dm1y * 100) /100,
          thisMonthLastYearPeriodValue: scatsData.stats.hoursDown.l30dm1y,
          previousMonthPeriodVariation: scatsData.stats.uptime.l30d - scatsData.stats.uptime.l30dm30d,
          thisMonthLastYearPeriodVariation: scatsData.stats.uptime.l30d - scatsData.stats.uptime.l30dm1y,
          lastYearPeriodVariation: scatsData.stats.uptime.ytd - scatsData.stats.uptime.ytdm1y,

        })
      }
    }

    return () => (isSubscribed = false);
  }, [endpoint, defaultValues, showMoreDigits]);

  if (isPhone) {
    // Phones: one block per period. The big figure sits in a fixed left column
    // and its comparisons stack on the right, one per line.
    const shared = {
      tooltipSubTitle,
      showMoreDigits,
      usePercentage,
      alterTooltip,
      breakpoint,
    };
    const mainValue = (period, extra) => (
      <MainValue
        compact
        {...shared}
        periodValuePercentage={info[`${period}ValuePercentage`]}
        periodDescription={info[`${period}Description`]}
        periodInterval={info[`${period}Interval`]}
        periodValue={info[`${period}Value`]}
        showActualNumber={showActualNumber}
        type={type}
        {...extra}
      />
    );
    const comparison = (period) => (
      <PercentageValue
        compact
        {...shared}
        periodValuePercentage={info[`${period}Percentage`]}
        periodDescription1={info[`${period}Description1`]}
        periodDescription2={info[`${period}Description2`]}
        periodVariation={info[`${period}Variation`]}
        periodInterval={info[`${period}Interval`]}
        periodValue={info[`${period}Value`]}
        invertArrows={invertArrows}
        invertColors={invertColors}
      />
    );
    const block = (heading, figure, comparisons) => (
      <Box>
        <Typography
          color="textSecondary"
          sx={{
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            mb: 0.5,
          }}
        >
          {heading}
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "minmax(104px, auto) 1fr",
            columnGap: 1.5,
            alignItems: "center",
          }}
        >
          {figure}
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.75 }}>
            {comparisons}
          </Box>
        </Box>
      </Box>
    );

    return (
      <Grid item xs={12}>
        {block(
          info.actualPeriodDescription,
          mainValue("actualPeriod", { includeUnits, primary: true }),
          comparison("lastYearPeriod"),
        )}
        <Divider
          sx={{
            my: 1.5,
            borderColor: theme.palette.primary.light,
            borderStyle: "dotted",
          }}
        />
        {block(
          info.lastMonthPeriodDescription,
          mainValue("lastMonthPeriod"),
          <>
            {comparison("previousMonthPeriod")}
            {comparison("thisMonthLastYearPeriod")}
          </>,
        )}
      </Grid>
    );
  }

  return (
    <Grid item sm={12} container spacing={1}>
      <Grid item xs={12} sm={5} container spacing={1} alignItems={"flex-end"}>
        <Grid
          item
          xs={showMoreDigits ? 5 : 6}
          container
          direction="column"
          alignItems="center"
        >
          <MainValue
            periodValuePercentage={info.actualPeriodValuePercentage}
            periodDescription={info.actualPeriodDescription}
            periodInterval={info.actualPeriodInterval}
            periodValue={info.actualPeriodValue}
            showActualNumber={showActualNumber}
            tooltipSubTitle={tooltipSubTitle}
            showMoreDigits={showMoreDigits}
            usePercentage={usePercentage}
            alterTooltip={alterTooltip}
            includeUnits={includeUnits}
            breakpoint={breakpoint}
            type={type}
            primary
          />
        </Grid>
        <Grid
          item
          xs={showMoreDigits ? 6 : 5}
          container
          direction="column"
          alignItems="center"
        >
          <PercentageValue
            periodValuePercentage={info.lastYearPeriodPercentage}
            periodDescription1={info.lastYearPeriodDescription1}
            periodDescription2={info.lastYearPeriodDescription2}
            periodVariation={info.lastYearPeriodVariation}
            periodInterval={info.lastYearPeriodInterval}
            periodValue={info.lastYearPeriodValue}
            tooltipSubTitle={tooltipSubTitle}
            showMoreDigits={showMoreDigits}
            usePercentage={usePercentage}
            alterTooltip={alterTooltip}
            invertArrows={invertArrows}
            invertColors={invertColors}
            breakpoint={breakpoint}
          />
        </Grid>

        <Grid
          item
          xs={1}
          container
          justifyContent="flex-end"
          sx={{ height: "100%" }}
        >
          <Divider
            orientation="vertical"
            sx={{
              borderRightColor: theme.palette.primary.light,
              borderRightStyle: "dotted",
              borderRightWidth: "1px",
              borderLeft: "none",
            }}
          />
        </Grid>
      </Grid>
      <Grid item xs={12} sm={7} container spacing={1} alignItems={"flex-end"}>
        <Grid item xs={4} container direction="column" alignItems="center">
          <MainValue
            periodValuePercentage={info.lastMonthPeriodValuePercentage}
            periodDescription={info.lastMonthPeriodDescription}
            periodInterval={info.lastMonthPeriodInterval}
            periodValue={info.lastMonthPeriodValue}
            showActualNumber={showActualNumber}
            tooltipSubTitle={tooltipSubTitle}
            showMoreDigits={showMoreDigits}
            usePercentage={usePercentage}
            alterTooltip={alterTooltip}
            breakpoint={breakpoint}
            type={type}
          />
        </Grid>

        <Grid item xs={4} container direction="column" alignItems="center">
          <PercentageValue
            periodValuePercentage={info.previousMonthPeriodPercentage}
            periodDescription1={info.previousMonthPeriodDescription1}
            periodDescription2={info.previousMonthPeriodDescription2}
            periodVariation={info.previousMonthPeriodVariation}
            periodInterval={info.previousMonthPeriodInterval}
            periodValue={info.previousMonthPeriodValue}
            tooltipSubTitle={tooltipSubTitle}
            showMoreDigits={showMoreDigits}
            usePercentage={usePercentage}
            alterTooltip={alterTooltip}
            invertArrows={invertArrows}
            invertColors={invertColors}
            breakpoint={breakpoint}
          />
        </Grid>

        <Grid item xs={4} container direction="column" alignItems="center">
          <PercentageValue
            periodValuePercentage={info.thisMonthLastYearPeriodPercentage}
            periodDescription1={info.thisMonthLastYearPeriodDescription1}
            periodDescription2={info.thisMonthLastYearPeriodDescription2}
            periodVariation={info.thisMonthLastYearPeriodVariation}
            periodInterval={info.thisMonthLastYearPeriodInterval}
            periodValue={info.thisMonthLastYearPeriodValue}
            tooltipSubTitle={tooltipSubTitle}
            showMoreDigits={showMoreDigits}
            usePercentage={usePercentage}
            alterTooltip={alterTooltip}
            invertArrows={invertArrows}
            invertColors={invertColors}
            breakpoint={breakpoint}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
